import React from 'react';
import { Stack, Alert, AlertTitle, Fade } from '@mui/material';
import { useNotifications } from './NotificationProvider';

const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotifications();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed', top: 72, right: 16, zIndex: 1400,
        maxWidth: 380, width: '100%',
      }}
    >
      {notifications.map((notification) => (
        <Fade key={notification.id} in appear>
          <Alert
            severity={notification.type}
            variant="filled"
            onClose={() => removeNotification(notification.id)}
            sx={{
              boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
              alignItems: 'flex-start',
            }}
          >
            <AlertTitle sx={{ mb: 0 }}>{notification.title}</AlertTitle>
            {notification.message}
          </Alert>
        </Fade>
      ))}
    </Stack>
  );
};

export default NotificationContainer;
